import { useState } from 'react'
import { Box, Container, makeStyles, Typography } from '@material-ui/core'
import { useResearcherDocument, DocumentSopRequest, DocumentSop } from '../services/um/useResearcherDocument'
import useLoading from '../control/loading/useLoading'
import GroupedSopList from '../component/um/researcher-document/DocumentList'
import Panel from '../component/um/researcher-document/Panel'
import useTranslate from '../i18n/useTranslate'
import moment from 'moment'

const ResearcherDocuments = () => {
    const translate = useTranslate()
    const { getDocumentSop, downloadDocumentSop } = useResearcherDocument()
    const loadingHook = useLoading()
    const classes = useStyles()

    const [dataList, setDataList] = useState<DocumentSop[]>([])

    // ปล่อยว่างจนกว่าผู้ใช้จะเลือกเอง
    const [initialValue] = useState<DocumentSopRequest>({})
    const [rec, setRec] = useState<number | string | undefined>(undefined)
    // นับจำนวนครั้งที่ค้นหา ใช้เป็นส่วนหนึ่งของ key เพื่อบังคับให้ accordion mount ใหม่
    const [searchToken, setSearchToken] = useState(0)

    const fetchData = async (value: DocumentSopRequest) => {
        if (!value.rec) {
            setDataList([])
            setRec(undefined)
            setSearchToken((prev) => prev + 1)
            return
        }

        loadingHook.loadingOpen()
        try {
            const res = await getDocumentSop({ search: value.search, rec: value.rec })
            setDataList(res.data ?? [])
            setRec(value.rec)
            setSearchToken((prev) => prev + 1)
        } finally {
            loadingHook.loadingClose()
        }
    }

    const downloadDocument = async (value: DocumentSop) => {
        loadingHook.loadingOpen()
        try {
            const res = await downloadDocumentSop({ sumittedTypeID: value.id, rec })

            const url = window.URL.createObjectURL(res)
            const reportDate = moment(new Date()).format('yyyyMMDD')
            const a = document.createElement('a')
            a.href = url
            // ต้องตั้งชื่อเป็น ASCII ให้ตรงกับ Content-Disposition ที่ API ส่งมา
            // ไม่งั้น Windows Explorer แตก zip ที่ชื่อไฟล์มีอักขระนอก ANSI codepage ของเครื่องไม่ได้
            // (ขึ้น "contains characters that prevent its extraction")
            a.download = `SOP_Document_REC${rec ?? ''}_${reportDate}.zip`
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)
        } finally {
            loadingHook.loadingClose()
        }
    }

    const onClear = async (form: any) => {
        form.reset()
        setDataList([])
        setRec(undefined)
        setSearchToken((prev) => prev + 1)
    }

    return (
        <Container maxWidth="lg">
            <Box className={classes.card}>
                <Panel onSubmit={fetchData} initialValue={initialValue} onClear={onClear} />
            </Box>

            {dataList.length > 0 ? (
                <GroupedSopList
                    dataList={dataList}
                    rec={rec}
                    resetKey={searchToken}
                    onDownloadGroup={async (e) => await downloadDocument(e)}
                />
            ) : (
                <Box className={classes.empty}>
                    <Typography variant="body2" color="textSecondary" align="center">
                        {rec
                            ? translate.get('LABEL.NO_DATA_FOUND')
                            : `${translate.get('LABEL.PLEASE_SELECT')} ${translate.get('UM.RESEARCHER_DOC.REC')}`}
                    </Typography>
                </Box>
            )}
        </Container>
    )
}

const useStyles = makeStyles(() => ({
    card: {
        padding: 12,
        borderRadius: 12,
        border: '1px solid #e5e7eb',
        background: '#fff',
        marginBottom: 20,
    },
    empty: {
        padding: 48,
    },
}))

export default ResearcherDocuments
